module.exports = __webpack_public_path__ + "static/img/reward-bg.e505e5cb.png";